export default __webpack_public_path__ + "static/media/pictogramBeaconTravel48.28488864.svg";